import { Link } from 'react-router-dom';

const ASCII_COMING_SOON = `
  ██████╗ ██████╗ ███╗   ███╗██╗███╗   ██╗ ██████╗
 ██╔════╝██╔═══██╗████╗ ████║██║████╗  ██║██╔════╝
 ██║     ██║   ██║██╔████╔██║██║██╔██╗ ██║██║  ███╗
 ██║     ██║   ██║██║╚██╔╝██║██║██║╚██╗██║██║   ██║
 ╚██████╗╚██████╔╝██║ ╚═╝ ██║██║██║ ╚████║╚██████╔╝
  ╚═════╝ ╚═════╝ ╚═╝     ╚═╝╚═╝╚═╝  ╚═══╝ ╚═════╝

  ███████╗ ██████╗  ██████╗ ███╗   ██╗
  ██╔════╝██╔═══██╗██╔═══██╗████╗  ██║
  ███████╗██║   ██║██║   ██║██╔██╗ ██║
  ╚════██║██║   ██║██║   ██║██║╚██╗██║
  ███████║╚██████╔╝╚██████╔╝██║ ╚████║
  ╚══════╝ ╚═════╝  ╚═════╝ ╚═╝  ╚═══╝`;

export default function ComingSoon() {
  return (
    <div className="min-h-screen bg-navy-950 flex flex-col">
      <nav className="fixed top-0 left-0 right-0 z-50 bg-navy-950/95 backdrop-blur-sm border-b border-navy-800/50">
        <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
          <Link to="/" className="font-mono text-bone-white tracking-widest text-sm font-medium">
            BONESPAY
          </Link>
          <Link
            to="/"
            className="inline-flex items-center gap-2 font-mono text-xs text-bone-white/60 hover:text-bone-white transition-colors uppercase tracking-wider"
          >
            <span className="text-[13px]">←</span>
            Back
          </Link>
        </div>
      </nav>

      <main className="flex-1 flex items-center justify-center px-6">
        <div className="text-center max-w-3xl">
          <div className="overflow-x-auto flex justify-center mb-8">
            <pre className="font-mono text-[7px] sm:text-[9px] md:text-xs text-bone-white leading-tight whitespace-pre select-none drop-shadow-[0_0_30px_rgba(255,255,255,0.1)]">
              {ASCII_COMING_SOON}
            </pre>
          </div>

          <div className="w-16 h-px bg-navy-700/50 mx-auto mb-6" />

          <p className="font-sans text-bone-white/50 text-base md:text-lg max-w-lg mx-auto mb-8 leading-relaxed">
            We're building something great. This page will be available soon.
          </p>

          <div className="inline-block border border-navy-700/30 rounded-subtle bg-navy-900/30 px-6 py-3 mb-10">
            <p className="font-mono text-xs text-bone-white/30 tracking-wider">
              Want to be notified?{' '}
              <Link to="/register" className="text-bone-white/70 hover:text-bone-white transition-colors underline underline-offset-4">
                Create an account
              </Link>
            </p>
          </div>

          <div className="mt-8">
            <Link
              to="/"
              className="inline-flex items-center gap-2 font-mono text-sm font-medium bg-bone-white text-navy-900 px-8 py-3 rounded-subtle hover:bg-navy-100 transition-colors uppercase tracking-wider group"
            >
              <span className="group-hover:-translate-x-1 transition-transform text-[13px]">←</span>
              Return Home
            </Link>
          </div>
        </div>
      </main>

      <footer className="py-6 border-t border-navy-800/50">
        <p className="font-mono text-[10px] text-bone-white/20 uppercase tracking-wider text-center">
          &copy; {new Date().getFullYear()} BonesPay &mdash; A BONES R&D Project.
        </p>
      </footer>
    </div>
  );
}
